import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import { Select } from '@ui/components/core'
import { DynamicFormProps } from '@ui/interfaces'
import { SaveAndCancelButtons } from '@ui/pages/pipelinesWorkflow/components/DestinationForms/SaveAndCancelButtons'
import * as Yup from 'yup'

enum DatadogRegion {
  US1 = 'US1',
  US3 = 'US3',
  US5 = 'US5',
  EU = 'EU',
  AP1 = 'AP1',
  US1Fed = 'US1-FED',
}

const schema = Yup.object({
  region: Yup.string().oneOf(Object.values(DatadogRegion)).required('Region is required'),
  apiKey: Yup.string().required('Must specify your Datadog API key'),
}).required()

export default function DatadogLogs(props: DynamicFormProps) {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      region: DatadogRegion.US1,
      ...props.config,
    },
  })

  const { saveClick, cancelClick } = props

  const region = watch('region')

  return (
    <form onSubmit={handleSubmit(saveClick)}>
      {props.additionalInputs}
      <div>
        <label htmlFor="region" className="block text-sm font-medium leading-6 text-gray-900">
          Region*
        </label>
        <div className="mt-2 flex w-full rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
          <Select
            onChange={(region) => {
              if (props.disableInputs) return
              if (region) setValue('region', region as DatadogRegion)
            }}
            options={Object.values(DatadogRegion).map((region) => ({
              label: region,
              value: region,
            }))}
            value={region}
          />
        </div>
        {errors.region && <p className="mt-2 text-xs italic text-red-500">{errors.region.message}</p>}
        <div className="mt-6">
          <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
            API Key*
          </label>
          <div className="mt-2">
            <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-600 sm:max-w-md">
              <input
                {...register('apiKey')}
                type="text"
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                data-testid="new-relic-otel-api-key"
                placeholder="abc123"
                disabled={props.disableInputs}
              />
            </div>
          </div>
        </div>
        {errors.apiKey && <p className="mt-2 text-xs italic text-red-500">{errors.apiKey.message}</p>}
        {props.submitButton ? props.submitButton : <SaveAndCancelButtons cancelClick={cancelClick} />}
      </div>
    </form>
  )
}
